export default __webpack_public_path__ + "dba7d7d6572ba5cd311cfdb20b2cb4ce.png";